<template>
  <div>
    <v-card-title>
      <h3>Package Details</h3>
    </v-card-title>
    <v-divider></v-divider>

    <v-list>
      <v-list-tile ripple>
        <v-flex xs4 md2>
          <h5><b>Name</b></h5>
        </v-flex>
        <v-flex xs9 md10>
          {{ planData.name }}
        </v-flex>
      </v-list-tile>

      <v-list-tile ripple>
        <v-flex xs4 md2>
          <h5><b>Price</b></h5>
        </v-flex>
        <v-flex xs9 md10>
          {{ currencyFormat(quotationTotalPrice) }}
        </v-flex>
      </v-list-tile>

      <v-list-tile ripple v-if="formAnswer">
        <v-flex xs4 md2>
          <h5><b>Location of Wake</b></h5>
        </v-flex>
        <v-flex xs9 md10>
          <span>
            {{ formAnswer.form_answers.main_form.deceased_location_of_wake }}
          </span>
        </v-flex>
      </v-list-tile>
      <v-list-tile ripple>
        <v-flex xs4 md2>
          <h5><b>Wake Start Date</b></h5>
        </v-flex>
        <v-flex xs9 md10>
          <span v-if="caseData.is_preplan">
            N/A (preplan)
          </span>
          <span v-else>
            {{ moment(caseData.wake_start).format('YYYY-MM-DD') }}
          </span>
        </v-flex>
      </v-list-tile>
      <v-list-tile ripple>
        <v-flex xs4 md2>
          <h5><b>Wake End Date</b></h5>
        </v-flex>
        <v-flex xs9 md10>
          <span v-if="caseData.is_preplan">
            N/A (preplan)
          </span>
          <span v-else>
            {{ moment(caseData.wake_end).format('YYYY-MM-DD') }}
          </span>
        </v-flex>
      </v-list-tile>
      <v-list-tile ripple>
        <v-flex xs4 md2>
          <h5><b>Sending Time</b></h5>
        </v-flex>
        <v-flex xs9 md10>
          <span v-if="caseData.is_preplan">
            N/A (preplan)
          </span>
          <span v-else>
            {{ caseData.wake_sending_time ? caseData.wake_sending_time : '-' }}
          </span>
        </v-flex>
      </v-list-tile>
      <v-list-tile ripple>
        <v-flex xs4 md2>
          <h5><b>Leave Office Time</b></h5>
        </v-flex>
        <v-flex xs9 md10>
          <span v-if="caseData.is_preplan">
            N/A (preplan)
          </span>
          <span v-else>
            {{ caseData.leave_office_time ? caseData.leave_office_time : '-' }}
          </span>
        </v-flex>
      </v-list-tile>
      <v-list-tile ripple>
        <v-flex xs4 md2>
          <h5><b>Leave Wake Time</b></h5>
        </v-flex>
        <v-flex xs9 md10>
          <span v-if="caseData.is_preplan">
            N/A (preplan)
          </span>
          <span v-else>
            {{ caseData.leave_wake_time ? caseData.leave_wake_time : '-' }}
          </span>
        </v-flex>
      </v-list-tile>
      <v-list-tile ripple>
        <v-flex xs4 md2>
          <h5><b>Cremation / Burial Time</b></h5>
        </v-flex>
        <v-flex xs9 md10>
          <span v-if="caseData.is_preplan">
            N/A (preplan)
          </span>
          <span v-else>
            {{ caseData.leave_funeral_time ? caseData.leave_funeral_time : '-' }}
          </span>
        </v-flex>
      </v-list-tile>
    </v-list>

    <v-card-title>
      <h3>Payment Methods</h3>
    </v-card-title>
    <v-divider></v-divider>


    <v-layout row class="padded-row">
      <v-radio-group
        class="large-radio full-width"
        large
        v-model="payment_method"
        @change="updatePaymentData"
      >
        <v-layout row>
          <v-flex xs12 md2 class="first-row">
            <v-radio
              :label="'Credit Card'"
              :value="'credit_card'"
            />
          </v-flex>
          <v-flex xs12 md10 v-if="payment_method === 'credit_card'">
            <v-text-field v-model="payment_method_cc_datetime" label="Date and Time Client will head down to office" :disabled="closed"/>
            <v-text-field v-model="payment_method_cc_remarks" label="Other remarks" :disabled="closed"/>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs12 md2 class="first-row">
            <v-radio
              :label="'Cash'"
              :value="'cash'"
            />
          </v-flex>
          <v-flex xs12 md10 v-if="payment_method === 'cash'">
            <v-text-field v-model="payment_method_cash_collected_by" label="Cash collected by and amount" :disabled="closed"/>
            <v-text-field v-model="payment_method_cash_remarks" label="Other remarks" :disabled="closed"/>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs12 md2 class="first-row">
            <v-radio
              :label="'Cheque'"
              :value="'cheque'"
            />
          </v-flex>
          <v-flex xs12 md10 v-if="payment_method === 'cheque'">
            <v-text-field v-model="payment_method_cheque_collected_by" label="Cheque collected by" :disabled="closed"/>
            <v-text-field v-model="payment_method_cheque_remarks" label="Other remarks" :disabled="closed"/>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs12 md2 class="first-row">
            <v-radio
              :label="'Internet banking'"
              :value="'internet_banking'"
            />
          </v-flex>
          <v-flex xs12 md10 v-if="payment_method === 'internet_banking'">
            <v-text-field v-model="payment_method_ibanking_datetime" label="Date and Time of Transfer" :disabled="closed"/>
            <v-text-field v-model="payment_method_ibanking_remarks" label="Other remarks" :disabled="closed"/>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs12 md12 class="first-row">
            <v-btn color="primary"
              block
              v-if="payment_method && !closed"
              :loading="loading.updatePaymentInfo"
              :disabled="loading.updatePaymentInfo"
              @click="updatePaymentInfo"
            >
              Update Payment Info
            </v-btn>
          </v-flex>
        </v-layout>
      </v-radio-group>
    </v-layout>
  </div>
</template>

<script>
  import plansAPI from '@/api/resources/plans'
  import casesAPI from '@/api/resources/cases'
  // import { mapGetters } from 'vuex'

  export default {
    data () {
      return {
        planData: {},
        quotationTotalPrice: 0,
        loading: {
          updatePaymentInfo: false
        },
        caseModel: null,
        payment_method: null,
        payment_method_cc_datetime: null,
        payment_method_cc_remarks: null,
        payment_method_cash_collected_by: null,
        payment_method_cash_remarks: null,
        payment_method_cheque_collected_by: null,
        payment_method_cheque_remarks: null,
        payment_method_ibanking_datetime: null,
        payment_method_ibanking_remarks: null
      }
    },
    props: {
      plansid: {
        type: Number,
        required: true
      },
      casesid: {
        required: true
      },
      caseData: {
        type: Object
      }
    },
    computed: {
      /*
      ...mapGetters({
        getAllCases: 'getAllCases',
        caseById: 'getCaseById'
      }),
      */
      closed () {
        return this.caseData && this.caseData.status === 'closed'
      }
    },
    watch: {
      /*
      getAllCases (cases) {
        this.caseData = cases.find(cas => cas.id === parseInt(this.casesid))
      }
      */
    },
    created () {
      plansAPI.loadPlan(this.plansid).then(result => {
        this.planData = result
      })

      casesAPI.getQuotationTotalPrice(this.casesid).then(result => {
        this.quotationTotalPrice = result
      }, () => {})

      this.payment_method = this.caseData.payment_method
      this.payment_method_cc_datetime = this.caseData.payment_method_cc_datetime
      this.payment_method_cc_remarks = this.caseData.payment_method_cc_remarks
      this.payment_method_cash_collected_by = this.caseData.payment_method_cash_collected_by
      this.payment_method_cash_remarks = this.caseData.payment_method_cash_remarks
      this.payment_method_cheque_collected_by = this.caseData.payment_method_cheque_collected_by
      this.payment_method_cheque_remarks = this.caseData.payment_method_cheque_remarks
      this.payment_method_ibanking_datetime = this.caseData.payment_method_ibanking_datetime
      this.payment_method_ibanking_remarks = this.caseData.payment_method_ibanking_remarks

      /*
      casesAPI.loadCase(this.casesid).then(result => {
        this.caseData = result[0]
        const defaultPaymentData = {
          payment_method: null,
          payment_method_cc_datetime: null,
          payment_method_cc_remarks: null,
          payment_method_cash_collected_by: null,
          payment_method_cash_remarks: null,
          payment_method_cheque_collected_by: null,
          payment_method_cheque_remarks: null,
          payment_method_ibanking_datetime: null,
          payment_method_ibanking_remarks: null
        }
        this.caseData = Object.assign(this.caseData, defaultPaymentData)
        const paymentData = JSON.parse(result[0].payment_info) || { payment_method: null }
        this.caseData = Object.assign(this.caseData, paymentData)
        console.log('case data', this.caseData)
      }, () => {})
      */
    },
    methods: {
      currencyFormat (number) {
        return 'SGD $' + number.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      },
      updatePaymentData (value) {
        this.$emit('updatePaymentMethod', value)
      },
      async updatePaymentInfo () {
        this.loading.updatePaymentInfo = true
        const data = {
          payment_info: {
            payment_method: this.payment_method,
            payment_method_cc_datetime: this.payment_method_cc_datetime,
            payment_method_cc_remarks: this.payment_method_cc_remarks,
            payment_method_cash_collected_by: this.payment_method_cash_collected_by,
            payment_method_cash_remarks: this.payment_method_cash_remarks,
            payment_method_cheque_collected_by: this.payment_method_cheque_collected_by,
            payment_method_cheque_remarks: this.payment_method_cheque_remarks,
            payment_method_ibanking_datetime: this.payment_method_ibanking_datetime,
            payment_method_ibanking_remarks: this.payment_method_ibanking_remarks
          }
        }
        const response = await this.$axios.post(`${this.$store.getters.config.api_host}/api/cases/${this.casesid}/payment-info`, data)
        this.$emit('updatePaymentInfo', data)
        if (response) {
          this.loading.updatePaymentInfo = false
        }
        return true
      }
    }
  }
</script>

<style lang="stylus">
  .v-input.full-width .v-input__control {
    width: 100%;
  }
  .padded-row {
    padding: 0 16px;
  }
  .first-row {
    margin-top: 15px;
  }
</style>



// WEBPACK FOOTER //
// CasePlanDataTable.vue?27094166